import { render } from "./CasesOverview.vue?vue&type=template&id=f54b090a&scoped=true"
import script from "./CasesOverview.vue?vue&type=script&lang=js"
export * from "./CasesOverview.vue?vue&type=script&lang=js"

import "./CasesOverview.vue?vue&type=style&index=0&id=f54b090a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54b090a"]])

export default __exports__